<template>
  <div>
<!--        selector=".zoomable"-->
    <panzoom
        :options="{
          minZoom: 0.9,
          maxZoom: 2,
          bounds: true,
          boundsPadding: .3
        }"
        @init="onInit"
        @panstart="onPanStart"
        @pan="onPan"
        @panend="onPanEnd"
        @zoom="onZoom"
        @zoomend="onZoomEnd"
        @transorm="onTransform">
      <img src="https://picsum.photos/300" alt="Img">
      <div class="not-zoomable">I cannot be zoomed and panned</div>
      <div class="zoomable">I can be zoomed and panned</div>
      <p>You can zoom me</p>
    </panzoom>

    <div class="btn" @click="zoomTo">ZoomTo</div>
    <div class="btn" @click="moveTo">MoveTo</div>

<!--    <panzoom selector="#g1">-->
<!--      <svg height="210" width="400">-->
<!--        <g id="g1">-->
<!--          <path d="M150 0 L75 200 L225 200 Z" />-->
<!--        </g>-->
<!--      </svg>-->
<!--    </panzoom>-->
  </div>
</template>
<style lang="scss" scoped>
</style>
<script>
//
//// import vue-panzoom
//import panzoom from 'vue-panzoom'
//
//// install plugin
//// Vue.use();
//// Vue.use(panzoom, {componentName: 'yourpanzoom'});
  //
	export default{
	  datas(){
	    return {
        panzoomInstance:null,
      }
    },
    methods:{
      onInit: function(panzoomInstance, id) {
        this.panzoomInstance = panzoomInstance;
      },
      onPanStart(e){ console.log('onPanStart', e); },
      onPan(e){ console.log('pan', e); },
      onPanEnd(e){ console.log('onPanEnd', e); },
      onZoom(e){ console.log('onZoom', e); },
      onZoomEnd(e){ console.log('onZoomEnd', e); },
      onTransform(e){ console.log('onTransform', e); },
      zoomTo(e){
        console.log('zoomTo', e);
        // this.panzoomInstance.zoomTo(0, 0, 2);
        this.panzoomInstance.smoothZoom(0, 0, 2);
      },
      moveTo(e){
        console.log('moveTo', e);
        // this.panzoomInstance.moveTo(0, 0);
        this.panzoomInstance.smoothMoveTo(0, 0);
      },
    }
	}
</script>
